import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ServicesHero from './components/ServicesHero';
import ServicesCards from './components/ServicesCards';
import ServicesProcess from './components/ServicesProcess';
import { useTitle } from '@/hooks/useTitle';
import { SchemaOrg } from '@/components/base/SchemaOrg';

import PageCta from '@/components/feature/PageCta';

const siteUrl = import.meta.env.VITE_SITE_URL;

const schemaData = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  'name': '保險建築師服務項目',
  'provider': {
    '@type': 'ProfessionalService',
    'name': '保險建築師',
    'url': siteUrl,
  },
  'url': `${siteUrl}/services`,
  'description': '保險建築師提供個人醫療保險、家庭保障規劃、資產與風險管理、企業團體方案與保單健檢等全方位服務。',
  'hasOfferCatalog': {
    '@type': 'OfferCatalog',
    'name': '服務項目清單',
    'itemListElement': [
      {
        '@type': 'OfferCatalog',
        'name': '個人醫療保險規劃',
        'itemListElement': [
          { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': '住院醫療保險', 'description': '涵蓋住院、手術及相關醫療費用' } },
          { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': '重大疾病保險', 'description': '一次給付型保障，確診即理賠' } },
          { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': '癌症保險', 'description': '專注癌症治療與相關費用保障' } },
          { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': '實支實付醫療險', 'description': '實報實銷醫療費用，補足健保缺口' } },
        ],
      },
      {
        '@type': 'OfferCatalog',
        'name': '家庭保障規劃',
        'itemListElement': [
          { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': '壽險保障規劃', 'description': '為家人打造經濟安全網' } },
          { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': '意外險規劃', 'description': '全面意外風險防護' } },
          { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': '子女教育基金規劃', 'description': '確保孩子教育不中斷' } },
        ],
      },
      { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': '資產與風險管理', 'description': '退休金規劃、資產傳承與稅務優化' } },
      { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': '企業團體保險方案', 'description': '員工福利規劃與企業風險轉嫁' } },
      { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': '保單健檢服務', 'description': '定期檢視既有保單，確保保障與時俱進' } },
    ],
  },
};

export default function Services() {
  useTitle({
    title: '服務項目｜保險建築師醫療、家庭、資產規劃',
    description: '保險建築師提供個人醫療保險、家庭保障規劃、資產與風險管理、企業團體方案與保單健檢等全方位服務。',
    canonicalPath: '/services',
  });
  return (
    <main>
      <SchemaOrg data={schemaData} />
      <Navbar />
      <ServicesHero />
      <ServicesCards />
      <ServicesProcess />
      <PageCta />
      <Footer />
    </main>
  );
}